import React from 'react';

// Local Dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { memberAddEditAddresspreloader as MemberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';
import { NAVIGATION_TABS_TYPE } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberInfoCommunicationSettings as MemberInfoCommunicationSettings } from 'ui/views/widgets/memberInfoCommunicationSettings';
 *
 * // render
 * <MemberInfoCommunicationSettings propName='propValue'/>
 */

export const memberInfoCommunicationSettingsSuccess = ( props ) => {
    return (
        <div className='ui-member-info-communication-settings'>
            <WidgetsTabFlow
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
                navType={ NAVIGATION_TABS_TYPE.SECONDARY }
            />
        </div>
    );
};

// set display name
memberInfoCommunicationSettingsSuccess.displayName = 'memberInfoCommunicationSettings';

// set default props
memberInfoCommunicationSettingsSuccess.defaultProps = {};

// prop types
memberInfoCommunicationSettingsSuccess.propTypes = {};

/**---------------------------- */

// Preloader
export const memberInfoCommunicationSettingsPreloader = ( ) => {
    return (
        <div className='ui-member-info-communication-settings-preloader'>
            <div className='ui-member-info-communication-settings-preloader__tab-list'>
                <div className='ui-member-info-communication-settings-preloader__tab-list__tab'></div>
                <div className='ui-member-info-communication-settings-preloader__tab-list__tab'></div>
                <div className='ui-member-info-communication-settings-preloader__tab-list__tab'></div>
            </div>
            <div className='ui-member-info-communication-settings-preloader__tab-container'>
                <MemberAddEditAddresspreloader hideTitle={ true } />
            </div>
        </div>
    );
};

// set display name
memberInfoCommunicationSettingsPreloader.displayName = 'memberCommunicationSettingsPreloader';

// set default props
memberInfoCommunicationSettingsPreloader.defaultProps = {};

// prop types
memberInfoCommunicationSettingsPreloader.propTypes = {};

export const memberInfoCommunicationSettings = withNetworkState( memberInfoCommunicationSettingsPreloader, memberInfoCommunicationSettingsSuccess );
